import css from 'styled-jsx/css';

const styles = css`main{margin:20px}section{margin-top:2rem}ul{padding-inline-start:40px}`;

export default styles;